// ========================================
// 📄 src/components/leads/LeadCard.jsx
// ========================================
import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, Building, Calendar } from "lucide-react";
import { getStatusBadgeColor, getStatusLabel } from "../../utils/helpers";
import { formatDate } from "../../utils/formatters";

const LeadCard = ({ lead }) => {
  return (
    <Link
      to={`/leads/${lead.id}`}
      className="panel-quiet hover:shadow-soft-lg transition-all duration-200 block"
    >
      <div className="flex items-start justify-between gap-3">
        <div className="space-y-1">
          <h3 className="font-semibold text-lg text-[var(--color-text-primary)]">
            {lead.firstName} {lead.lastName}
          </h3>
          <p className="text-sm text-[var(--color-text-muted)]">
            {lead.jobTitle || "Fonction non renseignée"}
          </p>
        </div>
        <span className={getStatusBadgeColor(lead.status)}>
          {getStatusLabel(lead.status)}
        </span>
      </div>

      <div className="mt-4 space-y-2 text-sm text-[var(--color-text-secondary)]">
        <DetailRow
          icon={<Building className="w-4 h-4 text-[var(--color-text-muted)]" />}
          value={lead.company || "Entreprise non renseignée"}
        />
        <DetailRow
          icon={<Mail className="w-4 h-4 text-[var(--color-text-muted)]" />}
          value={lead.email || "Email non renseigné"}
          isTruncated
        />
        <DetailRow
          icon={<Phone className="w-4 h-4 text-[var(--color-text-muted)]" />}
          value={lead.phone || "Téléphone non renseigné"}
        />
      </div>

      <div className="mt-4 pt-4 border-t border-[var(--color-border-soft)] flex items-center justify-between text-xs text-[var(--color-text-muted)]">
        <div className="flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          <span>{formatDate(lead.prospectionDate)}</span>
        </div>
        <span className="font-semibold text-[var(--color-brand)] hover:text-[var(--color-brand-strong)]">
          Voir détails →
        </span>
      </div>
    </Link>
  );
};

const DetailRow = ({ icon, value, isTruncated }) => (
  <div className={`flex items-center gap-2 ${isTruncated ? "truncate" : ""}`}>
    {icon}
    <span className={isTruncated ? "truncate" : ""}>{value}</span>
  </div>
);

export default LeadCard;
